// THIS FILE CANNOT BE gitignore'd BUT ALSO CANNOT BE MODIFIED DURING DEVELOPMENT ¯\_(ツ)_/¯

// this is essentially your ".env.local" file (https://create-react-app.dev/docs/adding-custom-environment-variables/)
// we've eschewed build-time configuration because we'd have to build for each environment which goes against https://12factor.net/ principles (dev/prod parity)
// so we're using "container-up-time" configuration instead of build time
// check the Dockerfile for more information

// BASE urls for RT_SYNCHUB:
// DEV: api.sti.code
// QA: api.sti.plus
// STG: api.sti.works
// UAT: api.sti.click
// PROD: api.stiassist.com

module.exports = {
  RT_API: 'https://pmvx-qa1.sti.plus',
  RT_SYNCHUB: 'https://api.sti.plus',
  RT_S3_ASSETS: 'https://s3.ca-central-1.amazonaws.com/dv.consumer-portal',
  RT_KEYCLOAK_URL: 'https://sso-qa1.sti.plus/auth',
  RT_LOCAL_CONFIG: 'tb.json',
  RT_ENV: 'qa',
  RT_BUGSNAG: 'fd6605e9569a5e12c964b5ffdfdbf42b',
};
